var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticStyle: { "z-index": "600" },
      attrs: {
        "content-class": "dialogText",
        persistent: "",
        "max-width": "450",
        light: true,
      },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("SMS Bestätigungscode"),
              ]),
              _c("v-card-text", [
                _c(
                  "div",
                  { staticClass: "bigger-input" },
                  [
                    _c("div", [
                      _vm._v(
                        "Bitte gib den Bestätigungscode ein, den du gerade per SMS erhalten haben: "
                      ),
                    ]),
                    _c("div", { staticStyle: { height: "15px" } }),
                    _c("v-text-field", {
                      ref: "smsInput",
                      attrs: {
                        label: "SMS",
                        placeholder: "Bestätigungscode",
                        autofocus: true,
                        "hide-details": "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.doProcess.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.sms,
                        callback: function ($$v) {
                          _vm.sms = $$v
                        },
                        expression: "sms",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c("div", { staticClass: "mr-4 underline" }, [
                    _c(
                      "span",
                      {
                        staticClass: "pointer",
                        on: {
                          "&click": function ($event) {
                            $event.stopPropagation()
                            return _vm.cancleDialog.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Abbrechen")]
                    ),
                  ]),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-df okBtn",
                      attrs: { text: "" },
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.doProcess.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" Bestätigen ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }